/**
 * A Kuutio-agent's picture: the agent's avatar when it has one, otherwise its
 * initials (the slug, e.g. "K2") on a colour fixed by the slug.
 */
import React from 'react';
import styled from '@emotion/styled';

const HUES = [152, 200, 268, 28, 330, 90];
const hueOf = (slug = '') => HUES[[...slug].reduce((h, c) => h + c.charCodeAt(0), 0) % HUES.length];

const Circle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  border-radius: 50%;
  flex: 0 0 auto;
  overflow: hidden;
  background: hsl(${(p) => p.hue} 45% 32%);
  border: 2px solid hsl(${(p) => p.hue} 55% 55%);
  color: #fff;
  font-weight: 700;
  font-size: ${(p) => Math.round(p.size * 0.38)}px;
  letter-spacing: 0.02em;
  img { width: 100%; height: 100%; object-fit: cover; }
`;

export default function AgentAvatar({ speaker, size = 28 }) {
  const slug = speaker?.slug || '?';
  return (
    <Circle size={size} hue={hueOf(slug)} title={speaker?.name || slug}>
      {speaker?.avatarUrl ? <img src={speaker.avatarUrl} alt={speaker.name || slug} /> : slug.toUpperCase()}
    </Circle>
  );
}
